import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2022 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { PopupUtils } from "abreact/incubator/ui/popup/PopupUtils";
import { KeyboardUtilsReact } from "abreact/incubator/ui/utils/KeyboardUtilsReact";
import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbMenu, AbMenuContext, useCachedMenuItems } from "abreact/menu/AbMenu";
import { AbButtonIconSide } from "abreact/misc/AbButton";
import { AbItem } from "abreact/misc/AbItem";
import { AbPopupButton } from "abreact/misc/AbPopupButton";
import { KeyValue } from "abweb/utils/KeyboardUtils";
import * as React from "react";
export function AbMenuButton(props) {
  const {
    menuItems,
    dataFreshness,
    menuProps,
    label,
    icon,
    className,
    onClick,
    ...rest
  } = props;
  const {
    cachePath,
    isRoot,
    closeEntireMenu
  } = useCachedMenuItems({
    items: menuItems,
    dataFreshness: dataFreshness,
    skipCaching: true
  });
  const popupButtonRef = /*#__PURE__*/React.createRef();
  const inMenuButtonPopup = !!closeEntireMenu;
  const hidePopup = () => {
    popupButtonRef.current?.close();
  };
  const showPopup = () => {
    popupButtonRef.current?.open();
  };
  const keyHandler = KeyboardUtilsReact.makeKeyHandler([[isRoot ? KeyValue.ARROW_UP : KeyValue.ARROW_LEFT, hidePopup], [isRoot ? KeyValue.ARROW_DOWN : KeyValue.ARROW_RIGHT, showPopup]]);
  const calcIconAndLabel = () => {
    const hasLabel = !!label;
    if (!isRoot) return {
      label
    }; // In a nested menu icon is already factored into label
    if (hasLabel) return {
      label: icon ? /*#__PURE__*/React.createElement(AbItem, {
        icon: icon,
        label: label
      }) : label,
      icon: "absdk:chevron-down"
    };
    return {
      icon: icon ?? "absdk:chevron-down"
    };
  };
  return /*#__PURE__*/React.createElement(AbPopupButton, _extends({}, rest, {
    onClick: e => {
      onClick?.(e);
      e.stopPropagation();
      if (popupButtonRef.current?.isOpen && inMenuButtonPopup) {
        // Don't close the menu when it's already open.
        e.preventDefault();
      }
    },
    className: ReactUtils.classNamesString([className, "ab-menu-button"]),
    abRef: ReactUtils.mergeRefs(props.abRef, popupButtonRef),
    iconSide: AbButtonIconSide.RIGHT
  }, calcIconAndLabel(), {
    onChange: props.onToggleMenu,
    popupProps: {
      positioner: isRoot ? PopupUtils.VERTICAL_POSITIONER : PopupUtils.HORIZONTAL_POSITIONER,
      className: "ab-menu-button-popup",
      allowPropagation: {
        onMouseEnter: true,
        onMouseLeave: true
      }
    },
    popupContents: /*#__PURE__*/React.createElement(AbMenuContext.Provider, {
      value: {
        path: cachePath,
        closeEntireMenu: closeEntireMenu ?? hidePopup
      }
    }, /*#__PURE__*/React.createElement(AbMenu, _extends({
      items: menuItems
    }, menuProps, {
      autoFocus: true,
      dataFreshness: dataFreshness
    }))),
    eventHandlers: {
      onKeyDown: keyHandler
    }
  }));
}
//# sourceMappingURL=AbMenuButton.js.map
